import { Component } from '@angular/core';
import { AssetsComponent } from "../assets/assets.component";
import { KalakarAccountParentComponent } from '../kalakar-account-parent/kalakar-account-parent.component';

@Component({
  selector: 'app-account',
  imports: [KalakarAccountParentComponent],
  templateUrl: './account.component.html',
  styleUrl: './account.component.css'
})
export class AccountComponent {

}
